import { LibrarySearch } from '@/features/library/components/LibrarySearch.js';
import { useDiscoverShelves } from '@/features/library/hooks/useDiscoverShelves.js';

import { DiscoverGenreShelves } from '../components/DiscoverGenreShelves.js';
import { DiscoverTrendingRow } from '../components/DiscoverTrendingRow.js';
import { FeaturedBook } from '../components/FeaturedBook.js';
import { GenreChips } from '../components/GenreChips.js';

export function DiscoverPage(): JSX.Element {
  const { data } = useDiscoverShelves();
  const availableGenres = data?.shelves.map((s) => s.genre) ?? [];

  return (
    <div className="flex flex-col gap-8">
      <header>
        <h1 className="font-serif text-3xl font-semibold text-brown md:text-4xl xl:text-5xl">
          Découvrir
        </h1>
        <p className="mt-1 font-script text-lg text-brown-soft xl:text-xl">
          Explore le catalogue mondial 🌸
        </p>
      </header>

      <GenreChips availableGenres={availableGenres} />

      <LibrarySearch />

      <FeaturedBook />

      <DiscoverTrendingRow />

      <DiscoverGenreShelves />
    </div>
  );
}
